export enum SurveyEditPageStep {
  details = "details",
  questions = "questions",
  launch = "launch",
  notifications = "notifications",
  final = "final",
}
